import { PropsWithChildren } from "react";
import BaseTab, { TabProps as BaseTabProps } from "../shared/tabstrip/tab";

interface TabProps extends PropsWithChildren<BaseTabProps> {
  permissions?: string[];
}

const Tab: React.FC<TabProps> = ({ permissions, ...props }) => {
  return <BaseTab {...props} />;
};

export default Tab;
